/* eslint-disable max-len */
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import useApiCall from '../../../../hooks/useApiCall';
import usersService from '../../../../services/usersService';
import { UserBeingDeletedInterface } from '../../interfaces/UserBeingDeletedInterface';

interface UseDeleteCollaboratorInterface {
  loadUsers: (currentPage: number) => void;
  currentPage: number;
}

export default function useDeleteCollaborator({
  loadUsers,
  currentPage,
}: UseDeleteCollaboratorInterface) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [userBeingDeleted, setUserBeingDeleted] = useState<UserBeingDeletedInterface>({});

  const { apiCall } = useApiCall();

  const deleteCollaborator = useCallback(async () => {
    await apiCall({
      apiToCall: usersService.deleteUser,
      reqBody: JSON.stringify({
        list: [{ id: userBeingDeleted.id, associated_company: userBeingDeleted.associated_company || '' }],
      }),
      onStartLoad: () => {
        setModalDeleteShow(false);
        setIsDeleting(true);
      },
      onEndLoad: () => setIsDeleting(false),
      actionAfterResponse: (apiResponse) => {
        if (!apiResponse.success) {
          toast.error('Não foi possível excluir o colaborador. Por favor, tente novamente');
          setIsDeleting(false);
          return;
        }
        toast.success('Colaborador excluído com sucesso!');
        loadUsers(currentPage);
      },
      catchMessage: 'Não foi possível excluir o colaborador. Por favor, tente novamente'
    });
  }, [apiCall, userBeingDeleted.id, userBeingDeleted.associated_company, loadUsers, currentPage]);

  return {
    isDeleting,
    modalDeleteShow,
    setModalDeleteShow,
    userBeingDeleted,
    setUserBeingDeleted,
    deleteCollaborator,
  };
}
